(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(8695);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ ActivityLog; }
});

// UNUSED EXPORTS: formatter

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(7379);
// EXTERNAL MODULE: ./src/design-system/Text.ts
var Text = __webpack_require__(8204);
;// CONCATENATED MODULE: ./src/design-system/Measurement.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  white-space: nowrap;\n\n  &:not(:last-child):after {\n    content: "\\A";\n    white-space: pre-wrap;\n  }\n\n  @media (min-width: 768px) {\n    &:not(:last-child):after {\n      content: " / ";\n      font-weight: bolder;\n      font-size: 3rem;\n      color: var(--lightBlue);\n    }\n  }\n'
    ], [
        '\n  white-space: nowrap;\n\n  &:not(:last-child):after {\n    content: "\\\\A";\n    white-space: pre-wrap;\n  }\n\n  @media (min-width: 768px) {\n    &:not(:last-child):after {\n      content: " / ";\n      font-weight: bolder;\n      font-size: 3rem;\n      color: var(--lightBlue);\n    }\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  min-width: 6ch;\n  text-align: left;\n\n  @media (min-width: 768px) {\n    display: inline;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    font-variant-numeric: oldstyle-nums;\n    font-size: 2rem;\n\n    @media (min-width: 768px) {\n      font-size: 3rem;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var BaseEntry = (0,styled_components_browser_esm/* default */.ZP)(Text/* Text */.x).withConfig({
    componentId: "sc-5746ba9b-0"
})(_templateObject());
var BaseUnit = (0,styled_components_browser_esm/* default */.ZP)(Text/* Text */.x).withConfig({
    componentId: "sc-5746ba9b-1"
})(_templateObject1());
var BaseValue = (0,styled_components_browser_esm/* default */.ZP)(Text/* Text */.x).withConfig({
    componentId: "sc-5746ba9b-2"
})(_templateObject2());
var Unit = function(param) {
    var unit = param.unit, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseUnit, {
        as: "span",
        $fontWeight: 300,
        className: className,
        children: unit
    });
};
var Value = function(param) {
    var value = param.value, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseValue, {
        as: "span",
        $fontWeight: 300,
        className: className,
        children: value !== null && value !== void 0 ? value : "-"
    });
};
var defaultRenderAs = "span";
var Measurement = function(param) {
    var value = param.value, unit = param.unit, _renderAs = param.renderAs, renderAs = _renderAs === void 0 ? defaultRenderAs : _renderAs;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseEntry, {
        as: renderAs,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                value: value
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Unit, {
                unit: unit
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@styled-system/space/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(4460);
;// CONCATENATED MODULE: ./src/design-system/Table.tsx

function Table_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: visible;\n\n  ",
        ";\n\n  @media (min-width: 768px) {\n    ",
        ";\n  }\n\n  &:empty:first-child,\n  &:empty:last-child {\n    ",
        ";\n  }\n"
    ]);
    Table_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Table_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0;\n  empty-cells: show;\n"
    ]);
    Table_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Table_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n\n  &:last-child {\n    border-bottom: none;\n  }\n"
    ]);
    Table_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: right;\n  vertical-align: center;\n\n  ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var cellMixin = (0,styled_components_browser_esm/* css */.iv)(Table_templateObject(), (0,index_esm/* space */.Dh)({
    p: "0.75rem 0.375rem 0.75rem 0"
}), (0,index_esm/* space */.Dh)({
    p: "1.5rem 0.75rem 1.5rem 0"
}), (0,index_esm/* space */.Dh)({
    p: "1.5rem 0.75rem"
}));
var Table = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-f52230b0-0"
})(Table_templateObject1(), index_esm/* space */.Dh);
var Tr = styled_components_browser_esm/* default.tr.withConfig */.ZP.tr.withConfig({
    componentId: "sc-f52230b0-1"
})(Table_templateObject2());
var Th = styled_components_browser_esm/* default.th.withConfig */.ZP.th.withConfig({
    componentId: "sc-f52230b0-2"
})(_templateObject3(), cellMixin);
var Td = styled_components_browser_esm/* default.td.withConfig */.ZP.td.withConfig({
    componentId: "sc-f52230b0-3"
})(_templateObject4(), cellMixin);

// EXTERNAL MODULE: ./src/functional.ts
var functional = __webpack_require__(4447);
;// CONCATENATED MODULE: ./src/components/Fitbit/ActivityLog.tsx






var formatter = new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric"
});
var isBaseActivity = function(activity) {
    switch(activity.activityName){
        case "Walk":
        case "Sport":
        case "Run":
        case "Aerobic Workout":
            return true;
        default:
            return false;
    }
};
var isSwimming = function(act) {
    return act.activityName === "Swim";
};
var Body = function(param) {
    var activity = param.activity;
    if (isSwimming(activity)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Measurement, {
                    value: activity.distance,
                    unit: "km"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Measurement, {
                    value: (0,functional/* exists */.Gg)(activity.pace) ? (activity.pace / 60).toFixed(1) : "-",
                    unit: "min/km"
                })
            ]
        });
    }
    if (isBaseActivity(activity)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Measurement, {
                    value: activity.steps,
                    unit: "steps"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Measurement, {
                    value: activity.averageHeartRate,
                    unit: "bpm"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Measurement, {
        value: activity.averageHeartRate,
        unit: "bpm"
    });
};
var ActivityLog = function(param) {
    var activities = param.activities;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table, {
            my: 3,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tr, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                                colSpan: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    $textAlign: "left",
                                    $fontSize: "2rem",
                                    $fontWeight: 100,
                                    children: "Activities"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                    children: activities.map(function(activity) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tr, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Td, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Td, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                            $textAlign: "left",
                                            $fontSize: "2rem",
                                            $fontWeight: 300,
                                            children: activity.activityName
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                            $textAlign: "left",
                                            $fontWeight: 300,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                as: "time",
                                                dateTime: activity.startTime,
                                                $fontWeight: 300,
                                                children: formatter.format(new Date(activity.startTime))
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Td, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Measurement, {
                                            value: (activity.activeDuration / (60 * 1000)).toFixed(1),
                                            unit: "min"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Measurement, {
                                            value: activity.calories,
                                            unit: "Cals"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {
                                            activity: activity
                                        })
                                    ]
                                })
                            ]
                        }, activity.logId);
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ BackTo; },
/* harmony export */   "z": function() { return /* binding */ BackToTop; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _styled_system_space__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4460);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  text-align: right;\n\n  & > a {\n    font-family: Recursive, sans-serif;\n    text-decoration: underline;\n    font-size: 1.6rem;\n    color: var(--smokeyWhite);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Base = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, to = param.to, label = param.label;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
            href: to,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                children: label
            })
        })
    });
};
var StyledBase = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(Base).withConfig({
    componentId: "sc-a06ffe6f-0"
})(_templateObject(), (0,_styled_system_space__WEBPACK_IMPORTED_MODULE_2__/* .space */ .Dh)({
    mt: 4
}));
var BackToTop = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBase, {
        to: "#",
        label: "Back to top"
    });
};
var BackTo = function(param) {
    var to = param.to, label = param.label;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBase, {
        to: to,
        label: label
    });
};


/***/ }),

/***/ 2636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _styled_system_space__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4460);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7379);
/* harmony import */ var design_system_Global_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2047);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  ",
        ";\n  font-size: ",
        ";\n  font-weight: 400;\n\n  position: relative;\n  display: block;\n\n  border: 0;\n  text-transform: uppercase;\n  background-color: transparent;\n  cursor: pointer;\n\n  color: ",
        ";\n\n  color: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n\n    color: ",
        ';\n  }\n\n  &::before,\n  &::after {\n    background-color: transparent;\n    content: "";\n    display: block;\n    position: absolute;\n    height: calc(50% - 0.4rem);\n    width: 100%;\n    border: 1px solid ',
        ";\n    border: 1px solid var(--smokeyWhite);\n    left: 0;\n  }\n\n  &::before {\n    border-bottom: none;\n    top: 0;\n  }\n\n  &::after {\n    border-top: none;\n    bottom: 0;\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  &:disabled:active {\n    pointer-events: none;\n  }\n\n  &:focus,\n  &:focus-visible {\n    outline-color: var(--blue);\n    outline-offset: 4px;\n    outline-width: 2px;\n    outline-style: solid;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  /* LABEL  */\n  display: block;\n  position: relative;\n  overflow: hidden;\n  margin: 0;\n\n  &:before {\n    content: "";\n    height: 100%;\n    display: block;\n    position: absolute;\n    width: 100%;\n    left: 0;\n    bottom: 0;\n\n    border: 1px solid ',
        ";\n    border: 1px solid var(--smokeyWhite);\n\n    background-color: ",
        ";\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  /* Hover Effect */\n  content: "";\n  display: block;\n  position: absolute;\n  height: 100%;\n  width: 120%;\n  top: 0;\n  left: -5%;\n  z-index: 1;\n  background-color: rgba(0, 0, 0, 0.7);\n  transform: translateX(-100%) skew(-10deg);\n  transition: transform 0.3s ease-out;\n\n  ',
        ":hover & {\n    transform: translateX(0) skew(-10deg);\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  /* Label Text */\n  font-family: Recursive, sans-serif;\n  position: relative;\n  display: block;\n  padding: 1.9rem 3rem;\n  background-color: transparent;\n  z-index: 1;\n  color: inherit;\n\n  opacity: 1;\n  transition: color 0.2s ease-in, opacity 0.2s ease-in;\n\n  &:after {\n    content: "";\n    display: block;\n    position: absolute;\n    height: 0.6rem;\n    width: 0.6rem;\n    right: 0;\n    bottom: 0;\n\n    background-color: ',
        ';\n    background-color: var(--white);\n\n    transition: background-color 0.2s ease-in;\n  }\n\n  &[data-disabled="true"] {\n    opacity: 0.5;\n  }\n\n  ',
        ":hover &:after {\n    background-color: ",
        ";\n    background-color: var(--softDark);\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var BaseButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-8b867293-0"
})(_templateObject(), _styled_system_space__WEBPACK_IMPORTED_MODULE_2__/* .space */ .Dh, (0,_styled_system_space__WEBPACK_IMPORTED_MODULE_2__/* .space */ .Dh)({
    p: 2
}), function(param) {
    var _fontSize = param.fontSize, fontSize = _fontSize === void 0 ? "1.6rem" : _fontSize;
    return fontSize;
}, function(param) {
    var variant = param.variant;
    return variant === "outlined" ? design_system_Global_theme__WEBPACK_IMPORTED_MODULE_3__/* .theme.smokeyWhite */ .rS.smokeyWhite : design_system_Global_theme__WEBPACK_IMPORTED_MODULE_3__/* .theme.lightYellow */ .rS.lightYellow;
}, function(param) {
    var variant = param.variant;
    return variant === "outlined" ? "var(--smokeyWhite)" : "var(--lightYellow)";
}, function(param) {
    var variant = param.variant;
    return variant === "outlined" ? design_system_Global_theme__WEBPACK_IMPORTED_MODULE_3__/* .theme.white */ .rS.white : design_system_Global_theme__WEBPACK_IMPORTED_MODULE_3__/* .theme.yellow */ .rS.yellow;
}, function(param) {
    var variant = param.variant;
    return variant === "outlined" ? "var(--white)" : "var(--yellow)";
}, design_system_Global_theme__WEBPACK_IMPORTED_MODULE_3__/* .theme.smokeyWhite */ .rS.smokeyWhite);
var Label = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-8b867293-1"
})(_templateObject1(), design_system_Global_theme__WEBPACK_IMPORTED_MODULE_3__/* .theme.smokeyWhite */ .rS.smokeyWhite, function(param) {
    var variant = param.variant;
    return variant === "outlined" ? "transparent" : design_system_Global_theme__WEBPACK_IMPORTED_MODULE_3__/* .theme.softDark */ .rS.softDark;
}, function(param) {
    var variant = param.variant;
    return variant === "outlined" ? "transparent" : "var(--softDark)";
});
var HoverEffect = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-8b867293-2"
})(_templateObject2(), BaseButton);
var Text = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-8b867293-3"
})(_templateObject3(), design_system_Global_theme__WEBPACK_IMPORTED_MODULE_3__/* .theme.white */ .rS.white, BaseButton, design_system_Global_theme__WEBPACK_IMPORTED_MODULE_3__/* .theme.softDark */ .rS.softDark);
var Button = function(_param) /*#__PURE__*/ {
    var _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "variant",
        "disabled",
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BaseButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        disabled: disabled,
        variant: variant
    }, rest), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Label, {
            variant: variant,
            children: [
                !disabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HoverEffect, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                    "data-disabled": disabled,
                    children: children
                })
            ]
        })
    }));
};



/***/ }),

/***/ 2057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ BlockEmoji; },
/* harmony export */   "d": function() { return /* binding */ Emoji; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _styled_system_space__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4460);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  font-weight: 400;\n  font-family: apple color emoji, segoe ui emoji, noto color emoji,\n    android emoji, emojisymbols, emojione mozilla, twemoji mozilla,\n    segoe ui symbol;\n  cursor: default;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var Base = function(param) {
    var className = param.className, ariaLabel = param.ariaLabel, symbol = param.symbol, title = param.title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
        className: className,
        role: "img",
        "aria-label": ariaLabel,
        title: title,
        children: symbol
    });
};
var Emoji = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(Base).withConfig({
    componentId: "sc-937f7621-0"
})(_templateObject(), _styled_system_space__WEBPACK_IMPORTED_MODULE_2__/* .space */ .Dh);
var BlockEmoji = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(Emoji).withConfig({
    componentId: "sc-937f7621-1"
})(_templateObject1());


/***/ }),

/***/ 9336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$0": function() { return /* binding */ Section; },
/* harmony export */   "Hn": function() { return /* binding */ FullPage; },
/* harmony export */   "M$": function() { return /* binding */ SectionHeader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _styled_system_space__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4460);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-height: 100vh;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var Section = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-d8092968-0"
})(_templateObject(), (0,_styled_system_space__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh)({
    my: 3,
    px: 2
}), _styled_system_space__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh);
var SectionHeader = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].header.withConfig */ .ZP.header.withConfig({
    componentId: "sc-d8092968-1"
})(_templateObject1(), (0,_styled_system_space__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh)({
    pt: 4
}), _styled_system_space__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh);
var FullPage = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(Section).withConfig({
    componentId: "sc-d8092968-2"
})(_templateObject2());


/***/ }),

/***/ 7945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ TextBox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7379);
/* harmony import */ var design_system_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1821);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: sans-serif;\n  max-width: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var defaultMax = "55ch";
var TextBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(design_system_Box__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .x).withConfig({
    componentId: "sc-c3ab26b1-0"
})(_templateObject(), function(param) {
    var _chars = param.chars, chars = _chars === void 0 ? defaultMax : _chars;
    return chars;
});


/***/ }),

/***/ 4447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gg": function() { return /* binding */ exists; },
/* harmony export */   "XT": function() { return /* binding */ circularSlice; },
/* harmony export */   "iu": function() { return /* binding */ circular; },
/* harmony export */   "kC": function() { return /* binding */ capitalize; }
/* harmony export */ });
/* unused harmony exports pipe, curry, curryRight, take, head, last, purify, split */


// Pipe
var pipe = function() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++){
        funcs[_key] = arguments[_key];
    }
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return funcs.reduce(function(val, func, i) {
            return i === 0 ? func.apply(void 0, _to_consumable_array(val)) : func(val);
        }, args);
    };
};
var curry = function(f) {
    return function(a) {
        return function() {
            for(var _len = arguments.length, b = new Array(_len), _key = 0; _key < _len; _key++){
                b[_key] = arguments[_key];
            }
            return f.apply(void 0, [
                a
            ].concat(_to_consumable_array(b)));
        };
    };
};
var curryRight = function(f) {
    return function() {
        for(var _len = arguments.length, b = new Array(_len), _key = 0; _key < _len; _key++){
            b[_key] = arguments[_key];
        }
        return function(a) {
            return f.apply(void 0, [
                a
            ].concat(_to_consumable_array(b)));
        };
    };
};
var take = function(n) {
    var m = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return function(array) {
        return array.slice(m, n + m);
    };
};
var head = function(param) {
    var _param = _sliced_to_array(param, 1), head = _param[0];
    return head;
};
var last = function(arr) {
    return head(arr.slice(-1));
};
var exists = function(val) {
    return val === (val !== null && val !== void 0 ? val : !val);
};
var purify = function(arr) {
    return arr.filter(exists);
};
var split = function(string, pattern) {
    return string.split(pattern);
};
var capitalize = function(string) {
    return "".concat(string.charAt(0).toUpperCase()).concat(string.slice(1));
};
function circular(index, step, limit) {
    return (limit + (index + step) % limit) % limit;
}
function circularSlice(arr, from, to) {
    var limit = arr.length;
    return Array.from({
        length: to - from
    }, function(_, index) {
        return arr[(from + index) % limit];
    });
}


/***/ }),

/***/ 8695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Home": function() { return /* binding */ Home; },
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/head.js
var next_head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(next_head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/design-system/Navigation.ts
var Navigation = __webpack_require__(1198);
;// CONCATENATED MODULE: ./src/components/PageNav.tsx




var PageNav = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation/* ContentNav */.C8, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation/* ContentLinks */.ER, {
                    children: react.Children.map(children, function(child) {
                        if (!/*#__PURE__*/ (0,react.isValidElement)(child)) return child;
                        var name = child.props.name;
                        if (!name) return null;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation/* ContentLink */._3, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/#".concat(name),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: name
                                })
                            })
                        });
                    })
                })
            }),
            children
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var src_sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@styled-system/space/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(4460);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(7379);
// EXTERNAL MODULE: ./src/design-system/Global/theme.ts
var theme = __webpack_require__(2047);
;// CONCATENATED MODULE: ./src/design-system/Card.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: Recursive, sans-serif;\n  ",
        ";\n\n  ",
        ";\n\n  background: ",
        ';\n  background: var(--softDark);\n\n  color: var(--smokeyWhite);\n\n  position: relative;\n  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.16), 0 3px 12px rgba(0, 0, 0, 0.23);\n\n  &::after {\n    content: "";\n    position: absolute;\n    z-index: -1;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    opacity: 0;\n    border-radius: 6px;\n    box-shadow: 0 9px 18px rgba(0, 0, 0, 0.3), 0 9px 18px rgba(0, 0, 0, 0.22);\n    transition: opacity 0.3s ease-in-out;\n  }\n\n  &:hover::after {\n    opacity: 1;\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 2rem;\n  font-weight: 300;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  display: flex;\n  flex-wrap: wrap;\n  flex-basis: 33%;\n\n  @media (min-width: 375px) {\n    flex-wrap: nowrap;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var BaseCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-765cede6-0"
})(_templateObject(), (0,index_esm/* space */.Dh)({
    py: 3,
    px: 3
}), index_esm/* space */.Dh, theme/* theme.softDark */.rS.softDark);
var Header = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-765cede6-1"
})(_templateObject1());
var Section = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-765cede6-2"
})(_templateObject2(), (0,index_esm/* space */.Dh)({
    mt: 4
}));

;// CONCATENATED MODULE: ./src/components/Card.tsx



var Card = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseCard, (0,_object_spread/* default */.Z)({}, props));
};
Card.Header = Header;
Card.Section = Section;

// EXTERNAL MODULE: ./src/design-system/Text.ts
var Text = __webpack_require__(8204);
;// CONCATENATED MODULE: ./src/components/CodeWars/Challenges.tsx


var Challenges = function(param) {
    var completed = param.completed;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
        $textColor: "--smokeyWhite",
        m: "0 auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                as: "span",
                $textColor: "--yellow",
                children: completed
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "challenges completed"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/design-system/DataEntry.ts

function DataEntry_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  text-align: center;\n\n  & > p,\n  & > span {\n    ",
        "\n    text-transform: capitalize;\n  }\n\n  & > p:first-child,\n  & > span:first-child {\n    font-size: 1.8rem;\n  }\n"
    ]);
    DataEntry_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var DataEntry = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bbb213eb-0"
})(DataEntry_templateObject(), (0,index_esm/* space */.Dh)({
    mx: 1,
    mt: 2
}), (0,index_esm/* space */.Dh)({
    my: 1
}));

// EXTERNAL MODULE: ./src/design-system/Emoji.tsx
var Emoji = __webpack_require__(2057);
;// CONCATENATED MODULE: ./src/components/CodeWars/Clan.tsx




var Clan = function(param) {
    var clan = param.clan;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DataEntry, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                $textColor: "--lightGreen",
                children: "clan"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Emoji/* BlockEmoji */.D, {
                symbol: "\uD83D\uDEE1\uFE0F",
                ariaLabel: "My clan: ".concat(clan)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                $textColor: "--smokeyWhite",
                children: clan
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/CodeWars/Honor.tsx




var Honor = function(param) {
    var honor = param.honor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DataEntry, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                $textColor: "--yellow",
                children: "honor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Emoji/* BlockEmoji */.D, {
                symbol: "\u2728",
                ariaLabel: "Honor: ".concat(honor)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                $textColor: "--smokeyWhite",
                children: honor
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/CodeWars/Leaderboard.tsx




var Leaderboard = function(param) {
    var position = param.position;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DataEntry, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                $textColor: "--lightYellow",
                children: "Rank"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Emoji/* BlockEmoji */.D, {
                symbol: "\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDCBB",
                ariaLabel: "Leaderboard position: ".concat(position)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                $textColor: "--smokeyWhite",
                children: position
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/functional.ts
var functional = __webpack_require__(4447);
;// CONCATENATED MODULE: ./src/components/CodeWars/Summary.tsx






function summaryColor(color) {
    var key = "light".concat((0,functional/* capitalize */.kC)(color));
    if ((0,theme/* isSupportedColor */.w6)(key)) {
        return "--".concat(key);
    }
    console.warn("".concat(key, " is not a supported color. Default to --white."));
    return "--white";
}
var Summary = function(param) {
    var _title = param.title, title = _title === void 0 ? "overall" : _title, name = param.name, score = param.score, color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DataEntry, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                $textColor: "--lightBlue",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Emoji/* BlockEmoji */.D, {
                symbol: "\uD83E\uDD80",
                ariaLabel: "".concat(name, " language")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                $textColor: summaryColor(color),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                $textColor: "--white",
                $fontSize: "1.4rem",
                children: [
                    score,
                    " exp"
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/design-system/Section.ts
var design_system_Section = __webpack_require__(9336);
;// CONCATENATED MODULE: ./src/components/Header.tsx



var Header_Header = function(param) {
    var name = param.name, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_Section/* SectionHeader */.M$, {
        id: name,
        mb: 3,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
            as: "h2",
            $fontSize: "3rem",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "#".concat(name),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                    children: title
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./src/design-system/BackToTop.tsx
var BackToTop = __webpack_require__(713);
// EXTERNAL MODULE: ./src/design-system/Flex.ts
var Flex = __webpack_require__(2976);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var node_modules_axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(node_modules_axios);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.esm.js
var dist_index_esm = __webpack_require__(821);
;// CONCATENATED MODULE: ./src/hooks/useCodeWars.ts


var fetcher = function() {
    return axios_default().get("/api/codewars").then(function(param) {
        var data = param.data;
        return data;
    });
};
var useCodeWars = function(fallbackData) {
    return (0,dist_index_esm/* default */.ZP)("code-wars", fetcher, {
        shouldRetryOnError: false,
        fallbackData: fallbackData,
        revalidateOnMount: true
    });
};

;// CONCATENATED MODULE: ./src/composition/CodeWars.tsx















var CodeWars = function(param) {
    var initial = param.initial, name = param.name;
    var ref = useCodeWars(initial), _data = ref.data, data = _data === void 0 ? initial : _data;
    var username = data.username, honor = data.honor, clan = data.clan, leaderboardPosition = data.leaderboardPosition, ranks = data.ranks, codeChallenges = data.codeChallenges;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_Section/* Section */.$0, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Header, {
                name: name,
                title: "CodeWars"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                mt: 3,
                $fontWeight: 300,
                children: [
                    "I like to solve coding challenges. For now I am only showing my",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.codewars.com/",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            as: "span",
                            $textColor: "--lightBlue",
                            $fontWeight: 400,
                            children: "Codewars"
                        })
                    }),
                    " ",
                    "profile, but I will eventually include more."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                mt: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
                    my: 2,
                    mx: "auto",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Header, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.codewars.com/users/icyJoseph",
                                    rel: "noopener noreferrer",
                                    target: "_blank",
                                    children: username
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card.Section, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Clan, {
                                    clan: clan
                                }),
                                Object.entries(ranks.languages).map(function(param) {
                                    var _param = (0,src_sliced_to_array/* default */.Z)(param, 2), name = _param[0], lang = _param[1];
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Summary, (0,_object_spread/* default */.Z)({
                                        title: name
                                    }, lang), name);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card.Section, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Honor, {
                                    honor: honor
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Leaderboard, {
                                    position: leaderboardPosition
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Section, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Challenges, {
                                completed: codeChallenges.totalCompleted
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackToTop/* BackToTop */.z, {})
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Fitbit/ActivityLog.tsx + 2 modules
var ActivityLog = __webpack_require__(2917);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/design-system/Fitbit/Badges.ts

function Badges_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  width: 75px;\n  height: 75px;\n  border-radius: 50%;\n  border: 1px solid var(--smokeyWhite);\n"
    ]);
    Badges_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Badges_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n\n  & ",
        " {\n    width: 100%;\n    max-width: 66.66%;\n  }\n\n  @media (min-width: 40em) {\n    flex-direction: row;\n\n    & ",
        " {\n      width: 100%;\n      max-width: 90%;\n    }\n  }\n"
    ]);
    Badges_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var Badge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f44a5409-0"
})(Badges_templateObject(), (0,index_esm/* space */.Dh)({
    my: 2,
    mx: "auto"
}));
var BadgesWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* Flex */.k).withConfig({
    componentId: "sc-f44a5409-1"
})(Badges_templateObject1(), BaseCard, BaseCard);

;// CONCATENATED MODULE: ./src/components/Fitbit/TopBadges.tsx







var TopBadges = function(param) {
    var profile = param.profile;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                as: "h3",
                $fontSize: "2rem",
                $fontWeight: 300,
                mt: 3,
                mb: 2,
                pl: "1.5rem",
                children: "Top Badges"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgesWrapper, {
                children: profile.topBadges.map(function(badge) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                        flex: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
                            my: 2,
                            mx: "auto",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Header, {
                                    children: badge.shortName
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Section, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DataEntry, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                $textColor: "--smokeyWhite",
                                                children: badge.description
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                                $textColor: "--smokeyWhite",
                                                children: [
                                                    "Achieved: ",
                                                    badge.timesAchieved,
                                                    " times"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: badge.image75px,
                                                    width: "75",
                                                    height: "75",
                                                    alt: badge.shortName,
                                                    loading: "lazy"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                $textColor: "--smokeyWhite",
                                                $fontWeight: 300,
                                                children: badge.shareText
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }, badge.encodedId);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/design-system/Box.ts
var Box = __webpack_require__(1821);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ./src/hooks/useFitbit.ts






var profileFetcher = function() {
    return axios.get("/api/fitbit/profile").then(function(param) {
        var data = param.data;
        return data.user;
    });
};
var useFitbitProfile = function() {
    var fallbackData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    return useSWR("fitbit/profile", profileFetcher, {
        shouldRetryOnError: false,
        fallbackData: fallbackData
    });
};
function heartRateFetcher(date, period) {
    return _heartRateFetcher.apply(this, arguments);
}
function _heartRateFetcher() {
    _heartRateFetcher = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(date, period) {
        var data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return axios_default().get("/api/fitbit/activities/heart/date/".concat(date, "/").concat(period)).then(function(param) {
                        var data = param.data;
                        return data;
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _heartRateFetcher.apply(this, arguments);
}
function activityLogFetcher(beforeDate) {
    return _activityLogFetcher.apply(this, arguments);
}
function _activityLogFetcher() {
    _activityLogFetcher = _async_to_generator(regeneratorRuntime.mark(function _callee(beforeDate) {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return axios.get("/api/fitbit/activities/list", {
                        params: {
                            beforeDate: beforeDate
                        },
                        paramsSerializer: function() {
                            var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                            return encodeURI(Object.entries(params).map(function(param) {
                                var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                                return "".concat(key, "=").concat(value);
                            }).join("&"));
                        }
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _activityLogFetcher.apply(this, arguments);
}
var useFitbitHR = function(param, fallbackData) {
    var date = param.date, period = param.period, _revalidateOnMount = param.revalidateOnMount, revalidateOnMount = _revalidateOnMount === void 0 ? false : _revalidateOnMount;
    return (0,dist_index_esm/* default */.ZP)([
        date,
        period
    ], function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return heartRateFetcher.apply(void 0, (0,_to_consumable_array/* default */.Z)(args));
    }, {
        shouldRetryOnError: false,
        revalidateOnFocus: false,
        revalidateOnMount: revalidateOnMount,
        fallbackData: fallbackData
    });
};
var useFitbitActivityLog = function(param) {
    var beforeDate = param.beforeDate, initial = param.initial;
    return useSWR(beforeDate, activityLogFetcher, {
        shouldRetryOnError: false,
        revalidateOnFocus: false,
        fallbackData: initial
    });
};

;// CONCATENATED MODULE: ./src/composition/Fitbit.tsx











var Fitbit = function(param) {
    var profile = param.profile, activityLog = param.activityLog, initialHR = param.initialHR, name = param.name;
    var ref, ref1;
    var data = useFitbitHR({
        date: "today",
        period: "1m",
        revalidateOnMount: true
    }, initialHR).data;
    var ref2;
    var heartData = (ref2 = data === null || data === void 0 ? void 0 : data["activities-heart"]) !== null && ref2 !== void 0 ? ref2 : [];
    var ref3 = (0,src_sliced_to_array/* default */.Z)(heartData.slice(-2), 2), tmp = ref3[0], prevDay = tmp === void 0 ? null : tmp, tmp1 = ref3[1], today = tmp1 === void 0 ? null : tmp1;
    var ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_Section/* Section */.$0, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Header, {
                name: name,
                title: "Fitbit"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                        mt: 2,
                        pb: 3,
                        flexDirection: "column",
                        gap: "2rem",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                flexDirection: "column",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        $fontSize: "2rem",
                                        $fontWeight: 300,
                                        children: "Average Daily Steps"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        m: 3,
                                        $fontSize: "5rem",
                                        children: profile.averageDailySteps
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        $fontSize: "2rem",
                                        $fontWeight: 300,
                                        children: "Resting pulse"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                        m: 3,
                                        $fontSize: "5rem",
                                        children: [
                                            (ref4 = today === null || today === void 0 ? void 0 : (ref = today.value) === null || ref === void 0 ? void 0 : ref.restingHeartRate) !== null && ref4 !== void 0 ? ref4 : prevDay === null || prevDay === void 0 ? void 0 : (ref1 = prevDay.value) === null || ref1 === void 0 ? void 0 : ref1.restingHeartRate,
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                as: "span",
                                                $fontWeight: 300,
                                                children: "bpm"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBadges, {
                        profile: profile
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityLog/* ActivityLog */.D, {
                        activities: activityLog
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackToTop/* BackToTop */.z, {})
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/design-system/Button.tsx
var Button = __webpack_require__(2636);
;// CONCATENATED MODULE: ./src/design-system/GitHub/Image.ts

function Image_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ';\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  width: 50%;\n\n  @media (min-width: 540px) {\n    width: 75%;\n  }\n\n  & > span {\n    box-shadow: 0 0 0 2px white;\n    border-radius: 50%;\n  }\n\n  & > span:before {\n    position: absolute;\n    content: "";\n    background-color: var(--background);\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n  }\n'
    ]);
    Image_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var GitHubImg = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-2aec8b44-0"
})(Image_templateObject(), (0,index_esm/* space */.Dh)({
    m: "auto"
}));

;// CONCATENATED MODULE: ./src/design-system/GitHub/Profile.ts

function Profile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-column: span 2;\n  justify-content: center;\n\n  display: grid;\n  grid-template-columns: 1fr;\n\n  @media (min-width: 768px) {\n    max-width: 75%;\n  }\n\n  @media (min-width: 540px) {\n    grid-template-columns: minmax(250px, 33.33%) 1fr;\n  }\n\n  > section {\n    ",
        ";\n\n    @media (min-width: 540px) {\n      ",
        ";\n    }\n  }\n\n  > section header {\n    text-align: center;\n\n    @media (min-width: 540px) {\n      text-align: left;\n    }\n  }\n"
    ]);
    Profile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Profile_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n"
    ]);
    Profile_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var Profile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d830f6d6-0"
})(Profile_templateObject(), (0,index_esm/* space */.Dh)({
    mx: "auto",
    mt: 4,
    px: 2
}), (0,index_esm/* space */.Dh)({
    mt: 0,
    px: 0
}));
var Bio = (0,styled_components_browser_esm/* default */.ZP)(Flex/* Flex */.k).withConfig({
    componentId: "sc-d830f6d6-1"
})(Profile_templateObject1());

;// CONCATENATED MODULE: ./src/helpers.ts

// softly scroll to top
var softTopScroll = function() {
    var documentElement = document.documentElement, body = document.body;
    var distance = documentElement.scrollTop || body.scrollTop;
    var step = 8;
    if (distance > 0) {
        window.requestAnimationFrame(softTopScroll);
        window.scrollTo(0, distance - distance / step);
    }
    return null;
};
// toggles the key on threshold pass
function onScrollThreshold(setter) {
    var threshold = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
    if (window.scrollY > threshold) {
        return setter(true);
    }
    return setter(false);
}
// a whole year span
var yearRange = function() {
    var year = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date().getFullYear();
    var to = new Date("".concat(year, "-12-31"));
    to.setUTCHours(23, 59, 59, 999);
    var from = new Date("".concat(year, "-01-01"));
    from.setUTCHours(0, 0, 0, 0);
    return {
        from: from.toISOString(),
        to: to.toISOString()
    };
};
function createClamp(min, max) {
    return function(val) {
        return Math.min(Math.max(val, min), max);
    };
}
var clamp = function(val, min, max) {
    return createClamp(min, max)(val);
};
var isoStringWithoutMs = function(iso) {
    return head(iso.split("."));
};
var trunc = function(num) {
    if (Math.trunc) return Math.trunc(num);
    return num < 0 ? Math.ceil(num) : Math.floor(num);
};

;// CONCATENATED MODULE: ./src/composition/GitHub.tsx

















var DynamicYearlyContribution = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6909).then(__webpack_require__.bind(__webpack_require__, 6909));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6909)
            ];
        }
    }
});
var RenderWithSelectedYear = function(param) {
    var last = param.last, children = param.children;
    var ref = (0,react.useState)(last), selectedYear = ref[0], setSelectedYear = ref[1];
    return children({
        selectedYear: selectedYear,
        setSelectedYear: setSelectedYear
    });
};
var GitHub = function(param) {
    var initial = param.initial, pageName = param.name;
    var bio = initial.bio, name = initial.name, company = initial.company, location = initial.location, login = initial.login, avatarUrl = initial.avatarUrl, contributionsCollection = initial.contributionsCollection, repositoryDiscussionComments = initial.repositoryDiscussionComments;
    var contributionYears = contributionsCollection.contributionYears;
    var _contributionYears = (0,src_sliced_to_array/* default */.Z)(contributionYears, 1), tmp = _contributionYears[0], last = tmp === void 0 ? new Date().getFullYear() : tmp;
    var totalAnswers = repositoryDiscussionComments.totalCount;
    var answersToRepos = (0,react.useMemo)(function() {
        return (0,_to_consumable_array/* default */.Z)(new Set(repositoryDiscussionComments.nodes.map(function(param) {
            var discussion = param.discussion;
            return discussion.repository.name;
        })));
    }, [
        repositoryDiscussionComments
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_Section/* Section */.$0, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Header, {
                name: pageName,
                title: "GitHub"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                flexDirection: "column",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Profile, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GitHubImg, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: avatarUrl,
                                    alt: "".concat(name, " github profile picture"),
                                    width: "460",
                                    height: "460"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                                as: "h3",
                                                $textColor: "--yellow",
                                                children: [
                                                    "@",
                                                    login
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                my: 2,
                                                $fontWeight: 300,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    children: location
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Bio, {
                                        flexDirection: "column",
                                        py: 3,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                mb: 2,
                                                $fontWeight: 300,
                                                children: bio
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                $textColor: "--yellow",
                                                mb: 2,
                                                children: company
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderWithSelectedYear, {
                        last: last,
                        children: function(param) {
                            var selectedYear = param.selectedYear, setSelectedYear = param.setSelectedYear;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                        $width: "80%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                            justifyContent: "center",
                                            my: 3,
                                            mx: "auto",
                                            children: contributionYears.slice(0).sort(function(a, b) {
                                                return a - b;
                                            }).map(function(year) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                    variant: year !== selectedYear ? "outlined" : "primary",
                                                    m: 2,
                                                    onClick: function() {
                                                        setSelectedYear(year);
                                                    },
                                                    children: year
                                                }, year);
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicYearlyContribution, (0,_object_spread/* default */.Z)({
                                        year: selectedYear,
                                        fallback: contributionsCollection
                                    }, yearRange(selectedYear)))
                                ]
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                        mt: 5,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                as: "h3",
                                $fontSize: "2.5rem",
                                mb: 3,
                                children: "Answers"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                $fontWeight: 300,
                                children: "Whenever possible I try to answer questions on the discussions for GitHub projects I support."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                $fontWeight: 300,
                                mt: 2,
                                children: [
                                    "In total I have",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        as: "span",
                                        $textColor: "--yellow",
                                        $fontWeight: 400,
                                        children: totalAnswers
                                    }),
                                    " ",
                                    "accepted answers, in these repositories:",
                                    " ",
                                    answersToRepos.map(function(repo, index, src) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                    as: "span",
                                                    $textColor: "--yellow",
                                                    $fontWeight: 400,
                                                    children: repo
                                                }),
                                                index < src.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: ", "
                                                })
                                            ]
                                        }, repo);
                                    }),
                                    "."
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackToTop/* BackToTop */.z, {})
        ]
    });
};

;// CONCATENATED MODULE: ./src/design-system/Bold.ts

function Bold_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline;\n  font-weight: 500;\n  font-size: inherit;\n  color: inherit;\n"
    ]);
    Bold_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Bold = styled_components_browser_esm/* default.b.withConfig */.ZP.b.withConfig({
    componentId: "sc-5460eced-0"
})(Bold_templateObject());

// EXTERNAL MODULE: ./src/design-system/TextBox.ts
var TextBox = __webpack_require__(7945);
;// CONCATENATED MODULE: ./src/composition/Introduction.tsx






var Introduction = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_Section/* Section */.$0, {
        mt: 0,
        pt: [
            2,
            3,
            4
        ],
        pb: "5%",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    as: "h1",
                    $textAlign: "center",
                    $fontSize: "3rem",
                    $fontWeight: 300,
                    my: 4,
                    children: "Joseph"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                    $textAlign: "center",
                    children: [
                        "github:",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://github.com/icyJoseph",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                children: "@icyJoseph"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                    $textAlign: "center",
                    children: [
                        "medium:",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://medium.com/@icjoseph",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                children: "@icjoseph"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextBox/* TextBox */.z, {
                    chars: "65ch",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                            mt: 4,
                            mx: "auto",
                            $fontWeight: 300,
                            $fontSize: "2rem",
                            children: [
                                "Developer from ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bold, {
                                    children: "Peru"
                                }),
                                ", living in ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bold, {
                                    children: "Sweden"
                                }),
                                ". I have a Bachelor's in Electronics Engineering, and a Master's degree on business design."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                            mt: 3,
                            mx: "auto",
                            $fontWeight: 300,
                            $fontSize: "2rem",
                            children: [
                                "I have over",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Bold, {
                                    title: "I do not believe in the value of this number.",
                                    children: [
                                        new Date().getFullYear() - 2016,
                                        " years"
                                    ]
                                }),
                                " ",
                                "of experience working as a software developer, in telecom, mining, freight, real state, news, transport and automotive industries."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                            mt: 3,
                            mx: "auto",
                            $fontWeight: 300,
                            $fontSize: "2rem",
                            children: [
                                "I write ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bold, {
                                    children: "JavaScript"
                                }),
                                ", and ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bold, {
                                    children: "TypeScript"
                                }),
                                ". I am comfortable with any runtime, browser and ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bold, {
                                    children: "NodeJS"
                                }),
                                ", even a little ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bold, {
                                    children: "Deno"
                                }),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                            mt: 3,
                            mx: "auto",
                            $fontWeight: 300,
                            $fontSize: "2rem",
                            children: [
                                "Learning ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bold, {
                                    children: "Rust"
                                }),
                                " on my free time, in fact it is my go to language for coding challenges."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                            mt: 3,
                            mx: "auto",
                            $fontWeight: 300,
                            $fontSize: "2rem",
                            children: [
                                "I enjoy writing ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bold, {
                                    children: "CSS"
                                }),
                                ", and keep my ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bold, {
                                    children: "HTML"
                                }),
                                " ",
                                "semantic."
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
;// CONCATENATED MODULE: ./src/design-system/CircularProgress.tsx

function CircularProgress_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    CircularProgress_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CircularProgress_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transform: rotate(-90deg);\n  fill: none;\n  stroke-linecap: round;\n"
    ]);
    CircularProgress_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CircularProgress_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  stroke: ",
        ";\n  stroke: var(--dark);\n"
    ]);
    CircularProgress_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  stroke: ",
        ";\n  stroke: var(--smokeyWhite);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var Progress = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-90db9f1c-0"
})(CircularProgress_templateObject());
var Svg = styled_components_browser_esm/* default.svg.withConfig */.ZP.svg.withConfig({
    componentId: "sc-90db9f1c-1"
})(CircularProgress_templateObject1());
var Circle = styled_components_browser_esm/* default.circle.withConfig */.ZP.circle.withConfig({
    componentId: "sc-90db9f1c-2"
})(CircularProgress_templateObject2(), theme/* theme.dark */.rS.dark);
var CircleFill = styled_components_browser_esm/* default.circle.withConfig */.ZP.circle.withConfig({
    componentId: "sc-90db9f1c-3"
})(_templateObject3(), theme/* theme.smokeyWhite */.rS.smokeyWhite);
var Overlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-90db9f1c-4"
})(_templateObject4());
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-90db9f1c-5"
})(_templateObject5());
var CircularProgress = function(param) {
    var percentage = param.percentage, _size = param.size, size = _size === void 0 ? 150 : _size, className = param.className, children = param.children;
    var center = size / 2;
    var strokeWidth = size * 0.05;
    var radius = size / 2 - strokeWidth / 2;
    var circumference = 2 * Math.PI * radius;
    var offset = (100 - percentage) / 100 * circumference;
    var style = {
        strokeDashoffset: offset
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Progress, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg, {
                width: size,
                height: size,
                viewBox: "0 0 ".concat(size, " ").concat(size),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Circle, {
                        className: "progress-track",
                        cx: center,
                        cy: center,
                        r: radius,
                        strokeWidth: strokeWidth
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleFill, {
                        className: "progress-thumb",
                        style: style,
                        cx: center,
                        cy: center,
                        r: radius,
                        strokeWidth: strokeWidth,
                        strokeDasharray: circumference
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: children
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Tokei/LoC.tsx





var LoC = function(param) {
    var language = param.language, code = param.code, blanks = param.blanks, comments = param.comments;
    var total = code + blanks + comments;
    var percentage = code / total * 100;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
        m: 2,
        px: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Header, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: language
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Section, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CircularProgress, {
                    percentage: percentage,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Emoji/* Emoji */.d, {
                            mb: 2,
                            symbol: "\uD83D\uDCDC",
                            ariaLabel: "Lines of ".concat(language, " code"),
                            title: "Lines of ".concat(language, " code")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                            children: code
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            children: "LoC"
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/composition/Tokei.tsx








var Tokei = function(param) {
    var tokei = param.tokei, name = param.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_Section/* Section */.$0, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Header, {
                name: name,
                title: "tokei ~/dev"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                mt: 3,
                $fontWeight: 300,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        as: "span",
                        $textColor: "--lightYellow",
                        $fontWeight: 400,
                        children: "Lines of Code"
                    }),
                    ", without counting ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "blanks"
                    }),
                    " or ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "comments"
                    }),
                    ", taken from my ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "dev"
                    }),
                    " folder, using",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        as: "a",
                        href: "https://github.com/XAMPPRocky/tokei",
                        target: "_blank",
                        rel: "noreferrer noopener",
                        $textColor: "--lightBlue",
                        $fontWeight: 400,
                        children: "tokei"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                mt: 2,
                $fontWeight: 300,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    children: "A full circle means 0 blank lines and 0 comments, only code."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                justifyContent: "center",
                mt: 4,
                children: tokei.map(function(_param) /*#__PURE__*/ {
                    var language = _param.language, rest = (0,_object_without_properties/* default */.Z)(_param, [
                        "language"
                    ]);
                    return (0,jsx_runtime.jsx)(LoC, (0,_object_spread/* default */.Z)({
                        language: language
                    }, rest), language);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                mt: 2,
                $fontWeight: 300,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    children: "I update these numbers about once a month."
                })
            })
        ]
    });
};


// EXTERNAL MODULE: ./src/design-system/Container.ts
var Container = __webpack_require__(8947);
;// CONCATENATED MODULE: ./src/pages/index.tsx










var VERCEL_URL = "https://".concat("icyjoseph-7ly8rlpou-icyjoseph.vercel.app");
var __N_SSG = true;
function Home(param) {
    var codewars = param.codewars, github = param.github, tokei = param.tokei, fitbit = param.fitbit, activityLog = param.activityLog, initialHR = param.initialHR;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "icyJoseph | Se\xf1or Developer",
                description: "Se\xf1or Developer. JavaScript, TypeScript, Rust, CSS. I work with fullstack. I enjoy coding challenges.",
                openGraph: {
                    url: VERCEL_URL,
                    title: "icyJoseph | Se\xf1or Developer",
                    site_name: "icyJoseph",
                    description: "Se\xf1or Developer. JavaScript, TypeScript, Rust, CSS. I work with fullstack. I enjoy coding challenges.",
                    images: [
                        {
                            url: "".concat(VERCEL_URL, "/waves_background.png"),
                            width: 960,
                            height: 540,
                            alt: "icyJoseph wavy background",
                            type: "image/png"
                        }, 
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "icyJoseph"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Introduction, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageNav, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tokei, {
                            tokei: tokei,
                            name: "tokei"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Fitbit, {
                            profile: fitbit,
                            activityLog: activityLog,
                            initialHR: initialHR,
                            name: "fitbit"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GitHub, {
                            initial: github,
                            name: "github"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeWars, {
                            initial: codewars,
                            name: "codewars"
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5565,2653,9774,2888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);